import styled from '@emotion/styled';
import css from '@styled-system/css';
import {
  space,
  layout,
  border,
  shadow,
  color,
  flexbox,
  background,
  position,
} from 'styled-system';

const View = styled('div')(
  {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  },
  ({ sx }) => (sx ? css(sx) : null),
  space,
  layout,
  color,
  flexbox,
  background,
  position,
  border,
  shadow,
);

View.displayName = 'Monterey(View)';

export default View;
